<template>
  <div>
    <p class="fw-600 title-table ">{{ $t("wap.text134") }} {{ dateTime }}</p>
    <div class="filter-container-price mb-20">
      <el-row :gutter="20">
        <el-col :sm="24" :md="12" :lg="8" :xl="8">
          <div
            @click="handleShowDialogSearchFacility"
            class="form-item-search-price"
          >
            <img
              style="width: 18px;"
              class="ml-10"
              :src="bg.icon_address"
              alt=""
            />
            <div
              :class="{ 'is-action': formRequest.sub_title }"
              style="position: relative;"
              class="full-width"
            >
              <el-autocomplete
                tabindex="-1"
                ref="noFocusAutocomplete"
                :value="formRequest.sub_title"
                class="full-width el-select-search-price"
                :trigger-on-focus="false"
                @focus="preventFocus"
                placeholder=" "
              >
              </el-autocomplete>
            </div>
            <label
              :class="{ 'label-action': formRequest.sub_title }"
              for="name"
              >{{ $t("chooseFacility") }}</label
            >
            <img
              class="mr-10"
              v-if="formRequest.sub_title"
              :src="bg.icon_closed"
              @click="handleReset($event)"
              alt=""
            />
            <img
              v-if="
                !formRequest.sub_title && getToken().bank_id == SOURCE_BANK.BIDV
              "
              class="mr-10"
              src="@/assets/img/v3/icon/arrow_down.svg"
              alt=""
            />
          </div>
        </el-col>
        <el-col :sm="24" :md="12" :lg="8" :xl="8" class="mt-10-mobile">
          <div class="form-item-search-price " style="padding:8px 0">
            <img
              style="width: 18px;"
              class="ml-10"
              :src="bg.icon_time"
              alt=""
            />
            <datetime
              :class="{ 'is-action': formRequest.date_played }"
              class="theme-custom-search-price full-width ml-10"
              v-model="formRequest.date_played"
              input-style="custom-input-search-price"
              format="dd-MM-yyyy"
              type="date"
              placeholder=" "
              input-class="custom-datetime"
              :phrases="{
                ok: $t('confirm'),
                cancel: $t('wap.text42')
              }"
            >
            </datetime>
            <img
              class="mr-10"
              v-if="query.date_played"
              :src="bg.icon_closed"
              @click="handleResetDatePlayed($event)"
              alt=""
            />
            <label
              :class="{ 'label-action': formRequest.date_played }"
              for="name"
              >{{ $t("choosetee") }}</label
            >
            <img
              v-if="
                !query.date_played && getToken().bank_id == SOURCE_BANK.BIDV
              "
              class="mr-10"
              src="@/assets/img/v3/icon/arrow_down.svg"
              alt=""
            />
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="mt-10 ">
      <el-table
        class="table-price-booking"
        :max-height="isMobile ? '' : 700"
        :data="flattenedData"
        :span-method="objectSpanMethod"
        style="width: 100%"
      >
        <!-- Cột facility_name với rowspan -->
        <el-table-column
          fixed
          prop="facility_name"
          :label="$t('wap.text136')"
          header-align="center"
          :width="isMobile ? '100' : ''"
        >
        </el-table-column>

        <!-- Group Teetime -->
        <el-table-column label="Teetime" header-align="center">
          <el-table-column
            prop="teetime_name"
            :label="$t('wap.text137')"
            header-align="center"
            align="center"
            :width="isMobile ? '130' : '200'"
          />
          <el-table-column
            prop="time_range"
            :label="$t('wap.text138')"
            header-align="center"
            align="center"
            :width="isMobile ? '150' : '300'"
          >
            <!-- <template slot-scope="{ row }">
              <p class="m-0">{{ row.date_start }}</p>
              ⬇️
              <p class="m-0">{{ row.date_end }}</p>
            </template> -->
          </el-table-column>
          <el-table-column
            :label="$t('wap.text139')"
            align="center"
            header-align="center"
            :width="isMobile ? '250' : '250'"
          >
            <template slot-scope="{ row }">
              <div class="btn-group">
                <el-button
                  class="btn"
                  v-for="(cust, cIndex) in row.customers"
                  :key="cIndex"
                >
                  {{ cust.name }}
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table-column>

        <!-- Cột price -->
        <el-table-column
          prop="price"
          :width="isMobile ? '150' : '250'"
          align="center"
          :label="$t('wap.text140') + ' (18 hole)'"
          header-align="center"
        />
      </el-table>
    </div>

    <div class="popup">
      <DialogSearchFacility
        @item-facility="handleFacility"
        @close="isShowDialog = false"
        :is-show-dialog="isShowDialog"
        :is-views-price="true"
      />
    </div>
  </div>
</template>
<script>
import { getBackGround, getToken, getLanguage } from "@/utils/wapAuth";
import { SOURCE_BANK } from "@/constant/contant";
import { Settings } from "luxon";
import DialogSearchFacility from "./DialogSearchFacility.vue";
import HomepageResource from "@/views/api/wapV2/homepage";
import { mapGetters, mapActions } from "vuex";
import { formatNumber, formatDate } from "@/utils/formatData";

Settings.defaultLocale = getLanguage() || "vi";

export default {
  name: "table-price-facility",
  components: {
    DialogSearchFacility
  },
  props: {
    isVietinbank: {
      type: Boolean,
      default: false
    }
  },
  created() {},
  mounted() {
    window.addEventListener("resize", this.checkDevice);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkDevice);
  },
  computed: {
    ...mapGetters(["listPriceFacility"]),
    flattenedData() {
      const result = [];
      this.listPriceFacility.forEach(group => {
        group.items.forEach(itemGroup => {
          itemGroup.data.forEach(item => {
            result.push({
              facility_name: group.facility_name,
              teetime_name: itemGroup.name,
              date_start: this.formatTime(item.time_start),
              date_end: this.formatTime(item.time_end),
              time_range: `${this.formatTime(
                item.time_start
              )} - ${this.formatTime(item.time_end)}`,
              customers: item.customers,
              price: `${this.formatNumber(item.price)} vnđ`,
              id: item.id
            });
          });
        });
      });
      return result;
    }
  },
  watch: {
    "formRequest.date_played"(val) {
      if (val) {
        const date = new Date(val);
        const timestamp = date.getTime();
        this.query.date_played = timestamp;
        this.dateTime = this.formatDate(date, "MM/YYYY");
      } else {
        this.dateTime = this.formatDate(new Date(), "MM/YYYY");
      }
      this.onGetData(true);
    }
  },
  data() {
    return {
      isMobile: window.innerWidth <= 768,
      dateTime: formatDate(new Date(), "MM/YYYY"),
      isShowDialog: false,
      isLoading: false,
      bg: getBackGround(),
      formRequest: {},
      query: {},
      SOURCE_BANK
    };
  },
  methods: {
    ...mapActions(["set_data_price_facility"]),
    checkDevice() {
      this.isMobile = window.innerWidth <= 768;
    },
    objectSpanMethod({ row, column, rowIndex }) {
      const data = this.flattenedData;

      if (column.property === "facility_name") {
        const facility = row.facility_name;
        const facilityRows = data.filter(r => r.facility_name === facility);
        const firstIndex = data.findIndex(r => r.facility_name === facility);
        if (rowIndex === firstIndex) {
          return { rowspan: facilityRows.length, colspan: 1 };
        }
        return { rowspan: 0, colspan: 0 };
      }

      if (column.property === "teetime_name") {
        const facility = row.facility_name;
        const teetime = row.teetime_name;
        const teetimeRows = data.filter(
          r => r.facility_name === facility && r.teetime_name === teetime
        );
        const firstIndex = data.findIndex(
          r => r.facility_name === facility && r.teetime_name === teetime
        );
        if (rowIndex === firstIndex) {
          return { rowspan: teetimeRows.length, colspan: 1 };
        }
        return { rowspan: 0, colspan: 0 };
      }

      return { rowspan: 1, colspan: 1 };
    },
    formatTime(input) {
      const [timePart, datePart] = input.split(",");
      const [hours, minutes] = timePart.split(":");
      return `${hours}:${minutes}`;
    },
    formatNumber,
    getToken,
    formatDate,
    onGetData(filter = false) {
      if (!filter && this.listPriceFacility.length > 0) return;
      this.isLoading = true;
      this.query.is_vietinbank = 1;
      HomepageResource.getPriceFacility(this.query)
        .then(res => {
          const { error_code, data } = res;
          if (error_code == 0) {
            const dataMap = data.map(i => ({
              facility_name: i.facility_name,
              items: [
                { name: this.$t("wap.text141"), data: i.list_normal },
                { name: this.$t("wap.text142"), data: i.list_weeken }
              ]
            }));
            this.$store.dispatch("set_data_price_facility", dataMap);
          }
        })
        .finally(() => {
          this.isLoading = true;
        });
    },
    handleShowDialogSearchFacility() {
      this.isShowDialog = true;
    },
    preventFocus() {
      this.$refs.noFocusAutocomplete.$el.querySelector("input").blur();
    },
    handleFacility(item) {
      if (item) {
        this.formRequest = {
          ...this.formRequest,
          sub_title: item.label,
          facility_id: item.value
        };

        this.isShowDialog = false;
        this.query.facility_id = item.value;
        this.onGetData(true);
      }
    },
    handleReset() {
      event.stopPropagation();
      (this.formRequest.sub_title = ""),
        (this.formRequest.facility_id = ""),
        (this.query.facility_id = ""),
        this.onGetData(true);
    },
    handleResetDatePlayed() {
      event.stopPropagation();
      this.query.date_played = "";
      this.formRequest.date_played = "";
    }
  }
};
</script>
<style lang="scss">
.el-table thead.is-group th.el-table__cell {
  background-color: v-bind("bg.c_button_main") !important;
  color: #ffff !important;
}
.el-table thead.is-group th.el-table_1_column_6 {
  border-right: none;
}
.el-table--border th.el-table__cell.gutter:last-of-type {
  border-bottom: none !important;
  /* border-bottom: 1px solid #EBEEF5; */
  /* border-bottom-width: 0px !important; */
}
.el-table tr {
  vertical-align: top !important;
  color: black;
  font-weight: 600;
  font-size: 14px;
  background: rgba(212, 230, 236, 1) !important;
}
.el-table__body tr.hover-row.current-row > td.el-table__cell,
.el-table__body
  tr.hover-row.el-table__row--striped.current-row
  > td.el-table__cell,
.el-table__body tr.hover-row.el-table__row--striped > td.el-table__cell,
.el-table__body tr.hover-row > td.el-table__cell {
  background: rgba(212, 230, 236, 1) !important;
}
.table-price-booking {
  border-radius: v-bind("bg.b_radius2");
  table {
    width: 100% !important;
  }
  .el-table__header-wrapper th {
    color: #333 !important;
    font-weight: bold;
  }

  /* Body background */
  .el-table__body-wrapper td {
    background: rgba(212, 230, 236, 1) !important;
    color: #000 !important;
  }
}
.form-item-search-price .el-input__inner {
  font-weight: 500;
  background-color: transparent;
  padding-left: 10px;
  font-size: v-bind("bg.fs_input") !important;
}
.form-item-search-price input::placeholder {
  color: v-bind("bg.c_placeholder") !important;
  font-size: v-bind("bg.fs_input") !important;
}
.theme-custom-search-price
  .vdatetime-calendar__month__day--selected
  > span
  > span,
.theme-custom-search-price
  .vdatetime-calendar__month__day--selected:hover
  > span
  > span {
  background: v-bind("bg.c_background3") !important;
}
.theme-custom-search-price .vdatetime-popup__header {
  background: v-bind("bg.colorMain") !important;
}

.vdatetime-popup {
  font-family: v-bind("bg.font") !important;
}
.theme-custom-search-price .vdatetime-year-picker__item--selected,
.theme-custom-search-price .vdatetime-time-picker__item--selected,
.theme-custom-search-price .vdatetime-popup__actions__button {
  color: v-bind("bg.colorMain") !important;
}
.theme-custom-search-price input {
  width: 100% !important;
  font-size: v-bind("bg.fs_input") !important;
}
.theme-custom-search-price input::placeholder {
  color: v-bind("bg.c_placeholder") !important;
  font-size: v-bind("bg.fs_input") !important;
}
.theme-custom-search-price input {
  color: v-bind("bg.c_input") !important;
}
.el-date-picker {
  width: 350px !important;
  left: 15px !important;
}
.el-date-picker .el-picker-panel__content {
  width: 330px !important;
}
.el-date-picker .el-picker-panel__content .el-date-table {
  font-size: 18px !important;
}
.el-date-picker .el-picker-panel__content .el-month-table {
  font-size: 18px !important;
}
.el-date-picker .el-picker-panel__content .el-year-table {
  font-size: 18px !important;
}
.el-date-picker .el-picker-panel__content .el-date-table td span {
  width: 27px !important;
  height: 25px !important;
}

.el-date-picker__header-label {
  font-size: 18px !important;
}
.el-select-search-price input {
  color: v-bind("bg.c_input") !important;
  border: none;
  border-radius: 8px;
}

.el-date-picker-add input {
  padding: 0 0 0 10px !important;
  border: none;
  border-radius: 8px;
  color: v-bind("bg.c_input") !important;
}

@media (max-width: 910px) {
  .el-table_1_column_1 {
    vertical-align: top !important;
  }
  .el-table tr {
    vertical-align: top !important;
    color: black;
    font-weight: 600;
    font-size: 12px;
    background: rgba(212, 230, 236, 1) !important;
  }
}
</style>
<style scoped lang="scss">
.filter-container-price {
  padding: 15px;
  background: #ffff;
  border: 1px solid rgba(226, 226, 226, 1);
  border-radius: v-bind("bg.b_radius2");
  margin: auto;
}
.form-item-search-price {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border: 0.87px solid v-bind("bg.c_border3");
  border-radius: v-bind("bg.b_radius1");
  height: 48.90697479248047px;
  .is-action {
    padding-top: 10px;
  }
  label {
    position: absolute;
    top: 50%;
    left: 35px;
    transform: translateY(-50%);
    font-size: 12px;
    color: v-bind("bg.c_placeholder") !important;
    transition: all 0.3s ease;
    pointer-events: none; // Không làm ảnh hưởng khi click vào
  }
  .label-action {
    top: 35%;
    font-size: 9px;
  }
}
.title-table {
  font-size: 16px;
}
.btn-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
}

.btn {
  background-color: v-bind("bg.c_background3") !important;
  color: white;
  font-size: 10px;
  border-radius: 8px;
  padding: 10px;
  border: none;
  margin-left: 0px !important;
  width: auto;
}

@media (max-width: 910px) {
  .mt-10-mobile {
    margin-top: 10px;
  }
  .title-table {
    font-size: 14px;
  }
}
</style>
